// Examen de certificación en «Mi certificación»: qué dice el botón y cuánto tiempo queda.
//
// Un intento se cuenta al ABRIRLO, y los intentos no se recuperan. El reloj lo fija el servidor
// (`expiraAt`) y sigue corriendo aunque el asesor cierre la ventana: mientras quede tiempo puede
// volver y retomarlo («Continuar examen»); al vencer, el servidor lo cierra y cuenta como usado.

/** Milisegundos que le quedan a un intento (0 si ya venció o no hay fecha). */
export function tiempoRestante(expiraAt, ahora = Date.now()) {
  if (!expiraAt) return 0
  const fin = new Date(expiraAt).getTime()
  if (Number.isNaN(fin)) return 0
  return Math.max(0, fin - ahora)
}

/** «mm:ss» para el reloj del examen. */
export function textoReloj(ms) {
  const s = Math.max(0, Math.ceil((ms || 0) / 1000))
  const mm = String(Math.floor(s / 60)).padStart(2, '0')
  const ss = String(s % 60).padStart(2, '0')
  return `${mm}:${ss}`
}

/**
 * Qué muestra el botón de un examen de la lista.
 * `accion`: 'retomar' (vuelve al intento abierto, sin gastar otro), 'confirmar' (pide confirmación
 * antes de abrir uno nuevo) o null (deshabilitado).
 */
/**
 * ¿El examen exige terminar el curso y todavía no está terminado? Si Academy no respondió
 * (`cursoRecomendado` nulo) no se bloquea aquí: el servidor decide al abrirlo.
 */
export function cursoPendiente(ex) {
  return !!ex?.requiereCursoCompletado && !!ex.cursoRecomendado && !ex.cursoRecomendado.completado
}

export function botonExamen(ex, ahora = Date.now()) {
  const i = ex?.intentos || {}
  const abiertoConTiempo = i.enCurso && tiempoRestante(i.enCursoExpiraAt, ahora) > 0
  if (abiertoConTiempo) return { texto: 'Continuar examen', accion: 'retomar' }
  if (i.agotados) return { texto: 'Sin intentos', accion: null }
  if (cursoPendiente(ex)) return { texto: 'Completa el curso primero', accion: null }
  if (ex?.prerequisitos && !ex.prerequisitos.cumple) return { texto: 'Comenzar examen', accion: null }
  if (ex?.enfriandoHasta && new Date(ex.enfriandoHasta).getTime() > ahora) return { texto: 'Comenzar examen', accion: null }
  return { texto: 'Comenzar examen', accion: 'confirmar' }
}

const CLAVE = (intentoId) => `cd2b-examen-respuestas-${intentoId}`

/** Respuestas marcadas de un intento, guardadas en este navegador para no perderlas al retomar. */
export function leerRespuestas(intentoId) {
  try {
    const v = window.localStorage.getItem(CLAVE(intentoId))
    const o = v ? JSON.parse(v) : {}
    return o && typeof o === 'object' ? o : {}
  } catch {
    return {}
  }
}

export function guardarRespuestas(intentoId, respuestas) {
  try { window.localStorage.setItem(CLAVE(intentoId), JSON.stringify(respuestas || {})) } catch { /* sin almacenamiento: se pierden al cerrar */ }
}

export function borrarRespuestas(intentoId) {
  try { window.localStorage.removeItem(CLAVE(intentoId)) } catch { /* nada */ }
}
